var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXmlFile = function SvgXmlFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C8.625 0 7.5 1.125 7.5 2.5V37.5C7.5 38.875 8.625 40 10 40H35C36.375 40 37.5 38.875 37.5 37.5V10L27.5 0H10Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10H37.5L27.5 0V7.5C27.5 8.875 28.625 10 30 10Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 17.5L30 10H37.5V17.5Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 32.5C32.5 33.1875 31.9375 33.75 31.25 33.75H3.75C3.0625 33.75 2.5 33.1875 2.5 32.5V20C2.5 19.3125 3.0625 18.75 3.75 18.75H31.25C31.9375 18.75 32.5 19.3125 32.5 20V32.5Z",
    fill: "#50BEE8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2562 25.4816L11.9962 23.3028C12.515 22.6241 13.525 23.4928 12.9562 24.1428C12.3575 24.8528 11.7275 25.6228 11.1262 26.4103L13.1662 28.949C13.715 29.699 12.6162 30.419 12.0762 29.679L10.2375 27.3203L8.42872 29.729C7.91872 30.4578 6.78872 29.639 7.35997 28.959L9.36872 26.4103C8.73872 25.6216 8.12872 24.8528 7.51997 24.1428C6.88997 23.3928 8.05997 22.6241 8.51872 23.3241L10.2562 25.4816Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7235 25.6102V29.3077C15.7235 29.749 15.3635 29.9977 15.0048 29.9977C14.6848 29.9977 14.4048 29.749 14.4048 29.3077V23.6815C14.4048 23.1615 14.846 22.9902 15.0048 22.9902C15.2935 22.9902 15.4635 23.1615 15.6335 23.3515L17.8335 26.319L20.111 23.2402C20.4423 22.8315 21.251 22.9902 21.251 23.6815V29.3077C21.251 29.749 20.971 29.9977 20.6523 29.9977C20.2923 29.9977 20.0123 29.749 20.0123 29.3077V25.6102L18.3523 27.709C17.9935 28.1502 17.5435 28.1502 17.2135 27.709L15.7235 25.6102Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9912 23.6823C22.9912 23.3523 23.2712 23.0723 23.6212 23.0723C23.9412 23.0723 24.2112 23.3535 24.2112 23.6823V28.6898H26.93C27.9087 28.6898 27.93 29.9985 26.93 29.9985H23.6225C23.2725 29.9985 22.9925 29.7498 22.9925 29.3885V23.6823H22.9912Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 33.75H7.5V35H31.25C31.9375 35 32.5 34.4375 32.5 33.75V32.5C32.5 33.1875 31.9375 33.75 31.25 33.75Z",
    fill: "#CAD1D8"
  })));
};
export default SvgXmlFile;